import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { logoutButtonClicked } from '../../../../auth/state/auth.actions';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-no-access',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './no-access.component.html',
  styleUrl: './no-access.component.scss',
})
export class NoAccessComponent {
  translate = inject(TranslateService);
  reason: string | null = '';
  store = inject(Store);

  constructor(private route: ActivatedRoute) {
    this.route.queryParamMap.subscribe((params) => {
      this.reason = params.get('reason');
    });
  }

  get message(): string {
    switch (this.reason) {
      case 'disabled':
        return this.translate.instant('no-access.messages.disabled');
      case 'pending-approval':
        return this.translate.instant('no-access.messages.pendingApproval');
      case 'no-access':
      case 'unauthorized':
      default:
        return this.translate.instant('no-access.messages.unauthorized');
    }
  }

  backToLogin(): void {
    this.store.dispatch(logoutButtonClicked());
  }
}
